
<template>
  <div :class="{'dh-psy-image': true, 'dh-psy-image--gradient': gradient }" aria-hidden>
    <div class="dh-psy-image__wrapper dh-psy-image__wrapper--small">
      <img :src="image.smallSrc" :srcset="image.smallSrcSet" alt="" sizes="100vw" data-object-fit="cover" data-object-position="top center">
    </div>
    <div class="dh-psy-image__wrapper dh-psy-image__wrapper--medium">
      <img :src="image.mediumSrc" :srcset="image.mediumSrcSet" alt="" sizes="100vw" data-object-fit="cover" data-object-position="top center">
    </div>
    <div class="dh-psy-image__wrapper dh-psy-image__wrapper--large">
      <img :src="image.largeSrc" :srcset="image.largeSrcSet" alt="" sizes="100vw" data-object-fit="cover" data-object-position="top center">
    </div>
  </div>
</template>

<script>
import { createSrcSet, createImageUrl } from '../../../lib/image-utils'
import { hasObjectFit } from '../../../polyfills/index.js'

export default {
  props: {
    imageId: {
      type: String,
      required: true
    },
    gradient: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    image() {
      const smallWidths = [320, 400, 450, 650]
      const largeWidths = [1200, 1360, 1550, 1800, 2400]
      const id = this.imageId
      return {
        smallSrcSet: createSrcSet({ id, widths: smallWidths, ratio: '3:4' }),
        smallSrc: createImageUrl({ id, width: 400, ratio: '3:4' }),
        mediumSrc: createImageUrl({ id, width: 1200, ratio: '1:1' }),
        mediumSrcSet: createSrcSet({ id, widths: largeWidths, ratio: '1:1' }),
        largeSrc: createImageUrl({ id, width: 1200, ratio: '16:9' }),
        largeSrcSet: createSrcSet({ id, widths: largeWidths, ratio: '16:9' })
      }
    }
  },
  mounted() {
    hasObjectFit() && import('objectFitPolyfill')
  }
}
</script>

<style scoped lang="postcss">
  .dh-psy-image--gradient .dh-psy-image__wrapper {
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50%;
      background: linear-gradient(to top, #141517, rgba(21, 22, 23, 0));
    }
  }

  .dh-psy-image__wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top center;
    }
  }

  .dh-psy-image__wrapper--small {
    display: block;

    @media (min-width: 900px) {
      display: none;
    }
  }

  .dh-psy-image__wrapper--medium {
    display: none;

    @media (min-width: 900px) {
      display: block;
    }

    @media (min-width: 1200px) {
      display: none;
    }
  }

  .dh-psy-image__wrapper--large {
    display: none;

    @media (min-width: 1200px) {
      display: block;
    }
  }
</style>
